import { css } from 'styled-components';

export const scrollbarStyle = (
  scrollbarColor: string,
  scrollbarBackgroundColor: string,
  scrollbarWidth = '12px',
  scrollbarBorder = '4px',
) => css`
  scrollbar-color: ${scrollbarColor} transparent;
  scrollbar-width: thin;
  ::-webkit-scrollbar {
    background-color: ${scrollbarBackgroundColor};
    width: ${scrollbarWidth};
  }
  ::-webkit-scrollbar-track {
    background-color: ${scrollbarBackgroundColor};
  }
  ::-webkit-scrollbar-track:hover {
    background-color: ${scrollbarBackgroundColor};
  }
  ::-webkit-scrollbar-thumb {
    background-color: ${scrollbarColor};
    border-radius: 12px;
    border: ${scrollbarBorder} solid ${scrollbarBackgroundColor};
  }
  ::-webkit-scrollbar-thumb: hover {
    border: ${scrollbarBorder} solid ${scrollbarBackgroundColor};
  }
`;
